/* global BX, FormUtils */

(function () {
    'use strict';

    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const form = document.getElementById('catalog-detail__question');
    if (!form) return;

    const submitBtn = form.querySelector('#submit-feedback-btn');
    const commonErrorsBlock = form.querySelector('#question-form-common-errors');
    const captchaContainerId = 'captcha-container-static-question';
    const containerSelector = '#catalog-detail__question';

    const fullname = form.querySelector('#fullname-question');
    const phone = form.querySelector('#phone-question');
    const email = form.querySelector('#email-question');
    const message = form.querySelector('#message-question');
    const productName = form.querySelector('#product-name');

    let staticCaptchaWidgetId = null;

    FormUtils.setupPhoneMask(phone);

    const renderCaptcha = () => {
        const container = document.getElementById(captchaContainerId);
        if (!container || staticCaptchaWidgetId !== null) return;

        try {
            staticCaptchaWidgetId = window.smartCaptcha.render(captchaContainerId, {
                sitekey: container.getAttribute('data-sitekey'),
                style: 'adaptive',
            });
        } catch (e) {
            console.error('Не удалось отрендерить капчу:', e);
        }
    };

    const initStaticCaptcha = () => {
        if (window.smartCaptcha) {
            renderCaptcha();
        } else {
            const checkInterval = setInterval(() => {
                if (window.smartCaptcha) {
                    clearInterval(checkInterval);
                    renderCaptcha();
                }
            }, 100);

            setTimeout(() => clearInterval(checkInterval), 10000);
        }
    };

    initStaticCaptcha();

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, '*Обязательное поле');
            isValid = false;
        }

        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, '*Введите корректный номер телефона (не менее 10 цифр)');
            isValid = false;
        }

        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, '*Введите корректный E-mail');
            isValid = false;
        }

        const captchaToken = form.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Пожалуйста, подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const clearFields = () => {
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';

        if (window.smartCaptcha) {
            if (staticCaptchaWidgetId !== null) {
                try {
                    window.smartCaptcha.reset(staticCaptchaWidgetId);
                    return;
                } catch (e) {
                    console.warn('Сброс по ID не удался, пробуем резервный метод...');
                }
            }
            try {
                const dynamicWidgetId = window.smartCaptcha.getResponse(captchaContainerId);
                window.smartCaptcha.reset(dynamicWidgetId);
            } catch (e) {
                window.smartCaptcha.reset();
            }
        }
    };

    const sendQuestion = async () => {
        if (!validate()) return;

        const captchaToken = form.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof BX.bitrix_sessid === 'function' ? BX.bitrix_sessid() : '';

        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            product_name: productName ? productName.value : '',
            smart_token: captchaToken ? captchaToken.value : '',
        };

        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerText = 'Отправка...';
        }

        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/ask-question',
                payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                submitBtn,
                commonErrorsBlock,
                containerSelector,
                onSuccess: (result) => {
                    alert(result.message || 'Спасибо! Ваше сообщение отправлено.');
                    clearFields();
                },
                onFieldError: (field, msg) => {
                    const el = form.querySelector(`#${field}`);
                    if (el) FormUtils.showFieldError(el, msg);
                },
            });
        } catch (e) {
            console.error(e);
        } finally {
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.innerText = 'Отправить';
            }
        }
    };

    if (submitBtn) {
        submitBtn.addEventListener('click', sendQuestion);
    }
})();
